/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable camelcase */
export default {
    s3: {
        transcodedMedia: {
            REGION: import.meta.env.REACT_APP_S3_TRANSCODED_UPLOADS_BUCKET_REGION,
            BUCKET: import.meta.env.REACT_APP_S3_TRANSCODED_UPLOADS_BUCKET
        },
        profilePictures: {
            REGION: import.meta.env.REACT_APP_S3_PROFILE_PICTURE_UPLOADS_BUCKET_REGION,
            BUCKET: import.meta.env.REACT_APP_S3_PROFILE_PICTURE_UPLOADS_BUCKET
        }
    },
    apiGateway: {
        apartments: {
            REGION: import.meta.env.REACT_APP_API_GATEWAY_REGION,
            URL: import.meta.env.REACT_APP_APARTMENTS_API_GATEWAY_URL
        },
        users: {
            REGION: import.meta.env.REACT_APP_API_GATEWAY_REGION,
            URL: import.meta.env.REACT_APP_USERS_API_GATEWAY_URL
        },
        applications: {
            REGION: import.meta.env.REACT_APP_API_GATEWAY_REGION,
            URL: import.meta.env.REACT_APP_APPLICATIONS_API_GATEWAY_URL
        },
        showings: {
            REGION: import.meta.env.REACT_APP_API_GATEWAY_REGION,
            URL: import.meta.env.REACT_APP_SHOWINGS_API_GATEWAY_URL
        },
        applicantAvailability: {
            REGION: import.meta.env.REACT_APP_API_GATEWAY_REGION,
            URL: import.meta.env.REACT_APP_APPLICANTAVAILABILITY_API_GATEWAY_URL
        },
        instantRent: {
            REGION: import.meta.env.REACT_APP_API_GATEWAY_REGION,
            URL: import.meta.env.REACT_APP_INSTANTRENT_API_GATEWAY_URL
        }
    },
    cognito: {
        REGION: import.meta.env.REACT_APP_COGNITO_REGION,
        USER_POOL_ID: import.meta.env.REACT_APP_COGNITO_USER_POOL_ID,
        APP_CLIENT_ID: import.meta.env.REACT_APP_COGNITO_APP_CLIENT_ID,
        IDENTITY_POOL_ID: import.meta.env.REACT_APP_COGNITO_IDENTITY_POOL_ID
    },
    iot: {
        aws_pubsub_region: import.meta.env.REACT_APP_IOT_REGION,
        aws_pubsub_endpoint: `wss://${import.meta.env.REACT_APP_IOT_ENDPOINT}/mqtt`
    }
};
